export const ResponseMessage = {
  ERROR_DEFAULT: 'Something went wrong',
};

export const roleEnums = {
  CUSTOMER_MANAGEMENT: 'Customer Mangement Portal Admin',
};

export const roleNumericEnums = {
  CUSTOMER_MANAGEMENT: '3',
};
